import BaseModal from '../Base/BaseModal';
import { RiFileExcel2Line } from 'react-icons/ri';
import './ExcelImportResultModal.css';

const ExcelImportResultModal = ({ isOpen, onClose, result }) => {
  if (!result) return null;

  const { totalRows, savedRows, errors = [], errorFileBase64 } = result;
  const hasErrors = errors.length > 0;

  // 행별 에러 그룹핑
  const errorsByRow = {};
  errors.forEach((e) => {
    if (!errorsByRow[e.row]) errorsByRow[e.row] = [];
    errorsByRow[e.row].push(e.message);
  });
  const errorRowEntries = Object.entries(errorsByRow).map(([row, msgs]) => ({
    row: Number(row),
    messages: msgs,
  }));

  const handleDownloadErrorFile = () => {
    if (!errorFileBase64) return;
    const byteChars = atob(errorFileBase64);
    const byteNumbers = new Uint8Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const blob = new Blob([byteNumbers], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = '업로드_오류내역.xlsx';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} title="엑셀 업로드 결과">
      <div className="excel-import-result">
        <div className="excel-import-summary">
          <div className="summary-item">
            <span className="summary-label">전체</span>
            <span className="summary-value">{totalRows}건</span>
          </div>
          <div className="summary-item success">
            <span className="summary-label">저장</span>
            <span className="summary-value">{savedRows}건</span>
          </div>
          {hasErrors && (
            <div className="summary-item error">
              <span className="summary-label">오류</span>
              <span className="summary-value">{errorRowEntries.length}건</span>
            </div>
          )}
        </div>

        {hasErrors ? (
          <>
            <div className="excel-import-error-table-wrapper">
              <table className="excel-import-error-table">
                <thead>
                  <tr>
                    <th>행</th>
                    <th>오류 내용</th>
                  </tr>
                </thead>
                <tbody>
                  {errorRowEntries.map((entry) => (
                    <tr key={entry.row}>
                      <td className="error-row-num">{entry.row}</td>
                      <td className="error-messages">
                        {entry.messages.map((msg, i) => (
                          <div key={i} className="error-msg-line">{msg}</div>
                        ))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {errorFileBase64 && (
              <div className="excel-import-actions">
                <button className="error-download-btn" onClick={handleDownloadErrorFile}>
                  <RiFileExcel2Line className="btn-icon" />
                  오류 파일 다운로드
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="excel-import-success">
            모든 데이터가 정상적으로 저장되었습니다.
          </div>
        )}
      </div>
    </BaseModal>
  );
};

export default ExcelImportResultModal;
